import './webinar-plus-frame.scss';
import WebinarPlusLogoEmbossed from '@/images/webinar_plus_logo_embossed.svg?react';

const WebinarPlusFrame = () => {
  return (
    <div className="webinar-plus-frame">
      <div className="top-border">
        <svg className="top-border-svg" viewBox="0 0 413 43" fill="none">
          <path
            d="M398.378 39.4058L404.622 32.5942C406.137 30.9412 408.277 30 410.519 30L413 30L413 -1.80528e-05L0.000427246 -1.80528e-05L0.000425935 30L2.4812 30C4.72366 30 6.86316 30.9412 8.37845 32.5942L14.6224 39.4058C16.1377 41.0588 18.2772 42 20.5197 42L392.481 42C394.723 42 396.863 41.0588 398.378 39.4058Z"
            fill="black"
          ></path>
          <path
            d="M413 30L410.519 30C408.277 30 406.137 30.9412 404.622 32.5942L398.378 39.4058C396.863 41.0588 394.723 42 392.481 42L20.5192 42C18.2768 42 16.1373 41.0588 14.622 39.4058L8.37802 32.5942C6.86274 30.9412 4.72324 30 2.48079 30L0 30"
            stroke="#474747"
          ></path>
        </svg>
      </div>
      <div className="left-border">
        <svg className="left-border-svg" viewBox="0 0 43 371" fill="none">
          <path
            d="M39.4058 14.622L32.5942 8.37802C30.9412 6.86274 30 4.72324 30 2.48079V0H0V371H30V368.519C30 366.277 30.9412 364.137 32.5942 362.622L39.4058 356.378C41.0588 354.863 42 352.723 42 350.481V20.5192C42 18.2768 41.0588 16.1373 39.4058 14.622Z"
            fill="black"
          ></path>
          <path
            d="M30 0V2.48079C30 4.72324 30.9412 6.86274 32.5942 8.37802L39.4058 14.622C41.0588 16.1373 42 18.2768 42 20.5192V350.481C42 352.723 41.0588 354.863 39.4058 356.378L32.5942 362.622C30.9412 364.137 30 366.277 30 368.519V371"
            stroke="#474747"
          ></path>
        </svg>
        <div className="pagination-indicator">
          <div className="top-circle" />
          <div className="top-line" />
          <div className="bottom-line" />
          <div className="bottom-circle" />
        </div>
      </div>
      <div className="right-border">
        <svg className="right-border-svg" viewBox="0 0 43 371" fill="none">
          <path
            d="M39.4058 14.622L32.5942 8.37802C30.9412 6.86274 30 4.72324 30 2.48079V0H0V371H30V368.519C30 366.277 30.9412 364.137 32.5942 362.622L39.4058 356.378C41.0588 354.863 42 352.723 42 350.481V20.5192C42 18.2768 41.0588 16.1373 39.4058 14.622Z"
            fill="black"
          ></path>
          <path
            d="M30 0V2.48079C30 4.72324 30.9412 6.86274 32.5942 8.37802L39.4058 14.622C41.0588 16.1373 42 18.2768 42 20.5192V350.481C42 352.723 41.0588 354.863 39.4058 356.378L32.5942 362.622C30.9412 364.137 30 366.277 30 368.519V371"
            stroke="#474747"
          ></path>
        </svg>
        <div className="pagination-indicator">
          <div className="top-circle" />
          <div className="top-line" />
          <div className="bottom-line" />
          <div className="bottom-circle" />
        </div>
      </div>
      <div className="bottom-border">
        <svg className="bottom-border-svg" viewBox="0 0 413 43" fill="none">
          <path
            d="M398.378 39.4058L404.622 32.5942C406.137 30.9412 408.277 30 410.519 30L413 30L413 -1.80528e-05L0.000427246 -1.80528e-05L0.000425935 30L2.4812 30C4.72366 30 6.86316 30.9412 8.37845 32.5942L14.6224 39.4058C16.1377 41.0588 18.2772 42 20.5197 42L392.481 42C394.723 42 396.863 41.0588 398.378 39.4058Z"
            fill="black"
          ></path>
          <path
            d="M413 30L410.519 30C408.277 30 406.137 30.9412 404.622 32.5942L398.378 39.4058C396.863 41.0588 394.723 42 392.481 42L20.5192 42C18.2768 42 16.1373 41.0588 14.622 39.4058L8.37802 32.5942C6.86274 30.9412 4.72324 30 2.48079 30L0 30"
            stroke="#474747"
          ></path>
        </svg>
        <WebinarPlusLogoEmbossed className="bottom-border-logo" />
      </div>
      <svg className="top-left-corner" viewBox="0 0 56 56" fill="none" id="svg-1434082686_641">
        <path
          d="M30 53.3137V56H0V0H56V30H53.3137C51.192 30 49.1571 30.8429 47.6569 32.3431L32.3431 47.6569C30.8429 49.1571 30 51.192 30 53.3137Z"
          fill="black"
        ></path>
        <path
          d="M32 21.5H27.5C24.1863 21.5 21.5 24.1863 21.5 27.5V32H20V22C20 20.8954 20.8954 20 22 20H32V21.5Z"
          fill="white"
        ></path>
        <path
          d="M32 21.5H27.5C24.1863 21.5 21.5 24.1863 21.5 27.5V32H20V22C20 20.8954 20.8954 20 22 20H32V21.5Z"
          fill="white"
        ></path>
        <path
          d="M30 56V53.3137C30 51.192 30.8429 49.1571 32.3431 47.6569L47.6569 32.3431C49.1571 30.8429 51.192 30 53.3137 30H56"
          stroke="#474747"
          fill="none"
        ></path>
      </svg>
      <svg className="top-right-corner" viewBox="0 0 56 56" fill="none" id="svg-1434082686_641">
        <path
          d="M30 53.3137V56H0V0H56V30H53.3137C51.192 30 49.1571 30.8429 47.6569 32.3431L32.3431 47.6569C30.8429 49.1571 30 51.192 30 53.3137Z"
          fill="black"
        ></path>
        <path
          d="M32 21.5H27.5C24.1863 21.5 21.5 24.1863 21.5 27.5V32H20V22C20 20.8954 20.8954 20 22 20H32V21.5Z"
          fill="white"
        ></path>
        <path
          d="M32 21.5H27.5C24.1863 21.5 21.5 24.1863 21.5 27.5V32H20V22C20 20.8954 20.8954 20 22 20H32V21.5Z"
          fill="white"
        ></path>
        <path
          d="M30 56V53.3137C30 51.192 30.8429 49.1571 32.3431 47.6569L47.6569 32.3431C49.1571 30.8429 51.192 30 53.3137 30H56"
          stroke="#474747"
          fill="none"
        ></path>
      </svg>
      <svg className="bottom-left-corner" viewBox="0 0 56 56" fill="none" id="svg-1434082686_641">
        <path
          d="M30 53.3137V56H0V0H56V30H53.3137C51.192 30 49.1571 30.8429 47.6569 32.3431L32.3431 47.6569C30.8429 49.1571 30 51.192 30 53.3137Z"
          fill="black"
        ></path>
        <path
          d="M32 21.5H27.5C24.1863 21.5 21.5 24.1863 21.5 27.5V32H20V22C20 20.8954 20.8954 20 22 20H32V21.5Z"
          fill="white"
        ></path>
        <path
          d="M32 21.5H27.5C24.1863 21.5 21.5 24.1863 21.5 27.5V32H20V22C20 20.8954 20.8954 20 22 20H32V21.5Z"
          fill="white"
        ></path>
        <path
          d="M30 56V53.3137C30 51.192 30.8429 49.1571 32.3431 47.6569L47.6569 32.3431C49.1571 30.8429 51.192 30 53.3137 30H56"
          stroke="#474747"
          fill="none"
        ></path>
      </svg>
      <svg className="bottom-right-corner" viewBox="0 0 56 56" fill="none" id="svg-1434082686_641">
        <path
          d="M30 53.3137V56H0V0H56V30H53.3137C51.192 30 49.1571 30.8429 47.6569 32.3431L32.3431 47.6569C30.8429 49.1571 30 51.192 30 53.3137Z"
          fill="black"
        ></path>
        <path
          d="M32 21.5H27.5C24.1863 21.5 21.5 24.1863 21.5 27.5V32H20V22C20 20.8954 20.8954 20 22 20H32V21.5Z"
          fill="white"
        ></path>
        <path
          d="M32 21.5H27.5C24.1863 21.5 21.5 24.1863 21.5 27.5V32H20V22C20 20.8954 20.8954 20 22 20H32V21.5Z"
          fill="white"
        ></path>
        <path
          d="M30 56V53.3137C30 51.192 30.8429 49.1571 32.3431 47.6569L47.6569 32.3431C49.1571 30.8429 51.192 30 53.3137 30H56"
          stroke="#474747"
          fill="none"
        ></path>
      </svg>
    </div>
  );
};

export default WebinarPlusFrame;
